import React from 'react';
import Header from '../components/Header';
import Section from '../components/Section';
import MedalsContainer from '../containers/MedalTable.container';
import MaterialContainer from '../containers/Materials.container';
import CalendarContainer from '../containers/Calendar.container';

const Index = () => (
    <React.Fragment>
        <Header mod={'page__header_medals'} />
        <Section
            title="Расписание"
            button={{ href: '/olympic2018/kalendar-olimpiada-2018#', text: 'Полное расписание' }}
            mod={'slide'}
        >
            <CalendarContainer limits={4} />
        </Section >
        <Section
            title="Медальный зачет"
            mod={'section_colored'}
        >
            <MedalsContainer limits={'all'} />
        </Section>
        <Section
            title="Материалы"
            button={{ href: '/olympic2018/materials#', text: 'Все материалы' }}
        >
            <MaterialContainer mlimits={7} nlimits={8} />
        </Section>
    </React.Fragment>
);

export default Index;



// WEBPACK FOOTER //
// ./src/pages/Medals.jsx